/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Screen_Done_EquipmentInputs */

const en_us2_onboarding_screen_done_equipment = /** @type {(inputs: Onboarding_Screen_Done_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I picked my equipment`)
};

const pt_br2_onboarding_screen_done_equipment = /** @type {(inputs: Onboarding_Screen_Done_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhi meus equipamentos`)
};

const es_419_onboarding_screen_done_equipment = /** @type {(inputs: Onboarding_Screen_Done_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegí mi equipo`)
};

const pt_pt2_onboarding_screen_done_equipment = /** @type {(inputs: Onboarding_Screen_Done_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhi o meu equipamento`)
};

const fr_fr2_onboarding_screen_done_equipment = /** @type {(inputs: Onboarding_Screen_Done_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'ai choisi mon matériel`)
};

const de_de2_onboarding_screen_done_equipment = /** @type {(inputs: Onboarding_Screen_Done_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe meine Ausrüstung gewählt`)
};

const it_it2_onboarding_screen_done_equipment = /** @type {(inputs: Onboarding_Screen_Done_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ho scelto la mia attrezzatura`)
};

/**
* | output |
* | --- |
* | "I picked my equipment" |
*
* @param {Onboarding_Screen_Done_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_screen_done_equipment = /** @type {((inputs?: Onboarding_Screen_Done_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Screen_Done_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_screen_done_equipment(inputs)
	if (locale === "es-419") return es_419_onboarding_screen_done_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_screen_done_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_screen_done_equipment(inputs)
	if (locale === "de-DE") return de_de2_onboarding_screen_done_equipment(inputs)
	if (locale === "it-IT") return it_it2_onboarding_screen_done_equipment(inputs)
	return en_us2_onboarding_screen_done_equipment(inputs)
});
export { onboarding_screen_done_equipment as "onboarding.screen_done.equipment" }